var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg39Trash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#172e08;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bounding_area"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "design"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.74,18.02c-0.41,0-0.75-0.34-0.75-0.75v-4.5c0-0.41,0.34-0.75,0.75-0.75s0.75,0.34,0.75,0.75v4.5 C14.49,17.68,14.16,18.02,13.74,18.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.25,18c-0.41,0-0.75-0.34-0.75-0.75v-4.5c0-0.41,0.34-0.75,0.75-0.75S11,12.34,11,12.75v4.5 C11,17.66,10.66,18,10.25,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.25,4h-7.5V2.75C12.75,2.34,12.41,2,12,2s-0.75,0.34-0.75,0.75V4h-7.5C3.34,4,3,4.34,3,4.75 C3,5.16,3.34,5.5,3.75,5.5h0.57l1.54,14.05C6.01,20.95,7.19,22,8.59,22h6.82c1.4,0,2.58-1.05,2.73-2.45L19.68,5.5h0.57 C20.66,5.5,21,5.16,21,4.75C21,4.34,20.66,4,20.25,4z M16.65,19.39c-0.07,0.63-0.6,1.11-1.24,1.11H8.59 c-0.64,0-1.17-0.48-1.24-1.11L6.27,9.5h11.46L16.65,19.39z M17.89,8H6.11L5.84,5.5h12.32L17.89,8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg39Trash);
export default __webpack_public_path__ + "static/media/39-trash.8e29dc02d72bade83ce935f9e3d4d449.svg";
export { ForwardRef as ReactComponent };